import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useBookingValidation(initialFormData = {}) {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const validateForm = useCallback((formData, turnstileToken = undefined) => {
    const newErrors = {};

    if (!formData.date) newErrors.date = t('validation_date_required');
    if (!formData.start_time) newErrors.start_time = t('validation_start_time_required');
    if (!formData.end_time) newErrors.end_time = t('validation_end_time_required');
    if (!formData.room) newErrors.room = t('validation_room_required');
    if (!formData.runggun) newErrors.runggun = t('validation_runggun_required');
    if (!formData.user) newErrors.user = t('validation_user_required');
    if (!formData.event_description) newErrors.event_description = t('validation_event_description_required');

    // Only validate turnstile if the argument is explicitly provided (not undefined)
    // If turnstileToken is passed as null, empty string, etc., it will fail.
    // If it is NOT passed (undefined), it is skipped.
    if (turnstileToken !== undefined && !turnstileToken) {
       newErrors.turnstile = t('validation_turnstile_required');
    }

    // Check if end time is after start time
    if (formData.start_time && formData.end_time) {
      const [startHour, startMin] = formData.start_time.split(':').map(Number);
      const [endHour, endMin] = formData.end_time.split(':').map(Number);
      const startMinutes = startHour * 60 + startMin;
      const endMinutes = endHour * 60 + endMin;

      if (endMinutes <= startMinutes) {
        newErrors.end_time = t('validation_end_time_after_start_time');
      }
    }

    // Check if date is not in the past
    if (formData.date) {
      const selectedDate = new Date(formData.date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        newErrors.date = t('validation_date_not_in_past');
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [t]);

  const clearError = useCallback((field) => {
    setErrors(prev => {
      if (prev[field]) {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      }
      return prev;
    });
  }, []);

  return { errors, setErrors, validateForm, clearError };
}
